import { useEffect, useState } from "react";

export function useIsPwa(): boolean {
  const [isPwa, setIsPwa] = useState(
    () =>
      typeof window !== "undefined" &&
      window.matchMedia("(display-mode: standalone)").matches,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;

    const mq = window.matchMedia("(display-mode: standalone)");
    const handler = (event: MediaQueryListEvent) => setIsPwa(event.matches);
    mq.addEventListener("change", handler);

    return () => mq.removeEventListener("change", handler);
  }, []);

  return isPwa;
}
